import type { LogLevel, Logger } from '../types';

export const createLogger = (
  level: LogLevel,
  externalLogger?: (...params: any) => void,
): Logger => {
  const logIt = (...params: any) => {
    console.log(...params);
    externalLogger?.(...params);
  };

  return {
    info(...params: any) {
      if (level !== 'silent') {
        logIt(...params);
      }
    },
    debug(...params: any) {
      if (level === 'debug') {
        logIt(...params);
      }
    },
    error(...params: any) {
      logIt(...params);
    },
  };
};
